/**
 * Lightweight in-memory flag for "the user just completed a Google auth redirect".
 * Used to let App.tsx skip the marketing shell and render AppAuthed immediately
 * without a full page reload (which caused the landing-page flicker).
 */

type Listener = () => void;
const listeners = new Set<Listener>();
let processed = false;

export const markAuthProcessed = (): void => {
  processed = true;
  listeners.forEach((l) => l());
};

export const isAuthProcessed = (): boolean => processed;

export const onAuthProcessed = (cb: Listener): (() => void) => {
  listeners.add(cb);
  if (processed) cb();
  return () => listeners.delete(cb);
};